var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 4.5V3H16.5V4.5V6.13776C13.1956 6.74992 10.5 9.34413 10.5 12.75C10.5 16.1559 13.1956 18.7501 16.5 19.3622V26.7905C14.6637 26.2529 13.5 24.7605 13.5 23.25H10.5C10.5 26.6559 13.1956 29.2501 16.5 29.8622V31.5V33H19.5V31.5V29.8622C22.8044 29.2501 25.5 26.6559 25.5 23.25C25.5 19.8441 22.8044 17.2499 19.5 16.6378V9.20952C21.3363 9.74708 22.5 11.2395 22.5 12.75H25.5C25.5 9.34413 22.8044 6.74992 19.5 6.13776V4.5ZM16.5 9.20952C14.6637 9.74708 13.5 11.2395 13.5 12.75C13.5 14.2605 14.6637 15.7529 16.5 16.2905V9.20952ZM19.5 19.7095V26.7905C21.3363 26.2529 22.5 24.7605 22.5 23.25C22.5 21.7395 21.3363 20.2471 19.5 19.7095Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "percent",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5L5 19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 2.5
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "hash",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4L5 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4L12 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9L20 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15L18 15"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_up_big",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64285 28.5L25.4679 12.675L25.4786 21L28.5 21L28.5 7.49999L15 7.49999L15 10.5214L23.325 10.5321L7.5 26.3571L9.64285 28.5Z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_big",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 4L3 12L11 20",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12H3",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_down",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19h11V8M5 5l14 14",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_left",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 6L5 12L11 18",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12H5",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42857 20L17.9786 7.44999L17.9857 16L20 16L20 3.99999L8 3.99999L8 6.01428L16.55 6.02142L4 18.5714L5.42857 20Z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_right",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5L21 12.5L13 20.5",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.5H2",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "geography",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 63L1 57V16l12 6v41zm38 0l-19-6-19 6m32-49c0 10-13 27-13 27S19 24 19 14c0-7.18 5.82-13 13-13s13 5.82 13 13zM32 57V44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20a6 6 0 100-12 6 6 0 000 12zm0 0v11M7 34v2m0 2v2m0 2v2m6-22l4-1m34 42l12-6V16l-12 6v41zm6-29v2m0 2v2m0 2v2m-6-22l-4-1"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "daypart",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M32 35a3 3 0 100-6 3 3 0 000 6zm3-3h9m-12-3V14m0 40v9m0-62v9M1 32h9m44 0h9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M55.005 44.127A25.887 25.887 0 0058 32c0-4.38-1.083-8.506-2.995-12.127l1.733-1A27.877 27.877 0 0160 32c0 4.744-1.18 9.212-3.262 13.128l-1.733-1.001zM44.127 55.004A25.886 25.886 0 0132 58c-4.38 0-8.506-1.083-12.127-2.995l-1 1.733A27.878 27.878 0 0032 60c4.744 0 9.212-1.18 13.128-3.262l-1.001-1.733zm1.731-1.001l1 1.733a28.147 28.147 0 008.879-8.877l-1.734-1a26.136 26.136 0 01-8.145 8.144zm9.879-36.862a28.147 28.147 0 00-8.878-8.877l-1 1.733a26.137 26.137 0 018.144 8.145l1.733-1.001zm-10.61-9.88A27.877 27.877 0 0032 4c-4.744 0-9.212 1.18-13.128 3.262l1.001 1.733A25.887 25.887 0 0132 6c4.38 0 8.506 1.083 12.127 2.995l1-1.733zm-36.863 9.88a28.146 28.146 0 018.877-8.877l1 1.733a26.137 26.137 0 00-8.144 8.145l-1.733-1zM4 32c0-4.744 1.18-9.212 3.262-13.128l1.733 1.001A25.887 25.887 0 006 32c0 4.38 1.083 8.506 2.995 12.127l-1.733 1A27.877 27.877 0 014 32zm13.141 23.736a28.145 28.145 0 01-8.877-8.877l1.733-1a26.136 26.136 0 008.145 8.144l-1.001 1.733z",
    clipRule: "evenodd"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "consumer_dynamics",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 44v-6m12 6v-6m5-14h-1a2 2 0 01-2-2v-2a2 2 0 00-2-2v-2l-4 2h-8a2 2 0 00-2 2v2a2 2 0 01-2 2m0 0h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16v11l1 1c0 5 3 12 10 12s10-7 10-12l1-1V14a4 4 0 00-4-4H28c-1.656 0-3 1.344-3 3h-1c-1.656 0-3 1.344-3 3zm7 36l-9-4 5-4 8 2v2l-4 4zm8 0l9-4-5-4-8 2v2l4 4zm-4 5v2m0-6v2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M58 49c3.207-4.881 5-10.723 5-17C63 14.879 49.121 1 32 1 14.879 1 1 14.879 1 32c0 6.278 1.792 12.118 5 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 48l3 1c6 2 6 5 6 5-5.617 5.674-13.384 9-22 9-8.553 0-16.391-3.398-22-9 0 0 0-3 6-5l3-1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M7 44l-1 5-5-1m56-4l1 5 5-1"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "competition",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.065 51.703A30.876 30.876 0 011 32C1 14.879 14.879 1 32 1c17.121 0 31 13.879 31 31M32 63a30.871 30.871 0 01-19.715-7.076m36.627-2.875A26.894 26.894 0 0132 59a26.877 26.877 0 01-13.998-3.907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.088 22A26.949 26.949 0 0159 32c0 6.375-2.21 12.234-5.904 16.854M32 5a26.887 26.887 0 0116.998 6.021M8.911 46.005A26.874 26.874 0 015 32m17.524-20.964A22.938 22.938 0 0132 9c12.703 0 23 10.297 23 23 0 3.73-.889 7.255-2.465 10.371M42.437 52.503A22.91 22.91 0 0132 55C19.297 55 9 44.703 9 32a22.89 22.89 0 012.976-11.323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.377 16.244A18.915 18.915 0 0132 13c7.801 0 14.504 4.701 17.43 11.426M13.968 38.004A18.977 18.977 0 0113 32c0-4.426 1.513-8.497 4.05-11.728m32.622 18.721C46.886 46.025 40.023 51 32 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.703 34.984C45.319 41.84 39.262 47 32 47c-8.284 0-15-6.716-15-15m15-15c7.248 0 13.296 5.142 14.695 11.977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 39a7 7 0 100-14 7 7 0 000 14zM10 57a3 3 0 100-6 3 3 0 000 6zm37-22a3 3 0 100-6 3 3 0 000 6zm4 19a3 3 0 100-6 3 3 0 000 6zM19 21a3 3 0 100-6 3 3 0 000 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 33a1 1 0 100-2 1 1 0 000 2z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "brand_kpis",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0V64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 59H64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 45L17 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 33L28 28H42L61 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11H23L29 17L35 11H40L47 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 23L61 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 32H61V27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 14V9H56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 48L61 44L57 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 44H44L38 38L30 46L11 27"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 8l-8 8-8-8"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11l7 7L22 6"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_giant",
    viewBox: "0 0 280 280",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 140.5L120.5 178L196.5 102"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "save",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.586 4H5a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V7.414a1 1 0 00-.293-.707l-2.414-2.414A1 1 0 0016.586 4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M8 12h8m-8 4h8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 5h8v3a1 1 0 01-1 1H9a1 1 0 01-1-1V5z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "blank",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M5 4v16a1 1 0 001 1h12a1 1 0 001-1V7.414a1 1 0 00-.293-.707l-3.414-3.414A1 1 0 0014.586 3H6a1 1 0 00-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7V3l5 5h-4a1 1 0 01-1-1z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9v6a2 2 0 01-2 2v2h16v-2a2 2 0 01-2-2V9A6 6 0 006 9zm7 4v3h-2v-3H8v-2h3V8h2v3h3v2h-3zm-1 9a2 2 0 002-2h-4a2 2 0 002 2z",
    clipRule: "evenodd"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "bar_chart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5H8v16h3V5zm-5 8H3v8h3v-8zm7-5h3v13h-3V8zm8 3h-3v10h3V11z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "line_chart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3v17a1 1 0 001 1h17v-2H5V3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.77 14.098a.985.985 0 001.374 0L21 9.344 19.627 8l-4.17 4.082-2.227-2.18a.985.985 0 00-1.374 0L7 14.656 8.373 16l4.17-4.082 2.227 2.18z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "location",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.13 3 5 6.13 5 10C5 15.25 12 21 12 21C12 21 19 15.25 19 10C19 6.13 15.87 3 12 3ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18L18 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6L18 18"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross_big",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 20 20 4M4 4l16 16"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross_giant",
    viewBox: "0 0 280 280",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97 183.5L183.5 97",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 97L183.5 183.5",
    strokeWidth: 4
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron_right",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6L15 12L9 18",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "command",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15.3 8.1C15.1 7.9 14.8 7.9 14.6 8.1L8.1 14.6C7.9 14.8 7.9 15.1 8.1 15.3L8.6 15.8C8.8 16 9.1 16 9.3 15.8L15.8 9.3C16 9.1 16 8.8 15.8 8.6L15.3 8.1Z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron_small",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9L12 15L18 9",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_small",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 11L10 16L19 7",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 15-5-6-5 6h10Z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_settings",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4666 9.38276L14 9.82364C14.253 10.0293 14.3207 10.388 14.16 10.672L13.3866 12.008C13.2267 12.2682 12.911 12.3864 12.62 12.2952L11.9533 12.0548C11.5599 11.9074 11.1202 11.9545 10.7666 12.1817C10.6099 12.2902 10.445 12.3862 10.2733 12.4689C9.89817 12.6617 9.63612 13.0209 9.56664 13.4375L9.45331 14.1055C9.40049 14.4322 9.1169 14.6709 8.78664 14.6666H7.2533C6.92304 14.6709 6.63946 14.4322 6.58664 14.1055L6.4733 13.4375C6.40382 13.0209 6.14177 12.6617 5.76664 12.4689C5.59497 12.3862 5.43002 12.2902 5.2733 12.1817C4.91978 11.9545 4.48007 11.9074 4.08664 12.0548L3.41997 12.2952C3.11714 12.408 2.77722 12.2869 2.6133 12.008L1.83997 10.672C1.67925 10.388 1.74692 10.0293 1.99997 9.82364L2.5333 9.38276C2.85667 9.1138 3.03455 8.70781 3.0133 8.28725V8.00001V7.71277C3.03455 7.29221 2.85667 6.88622 2.5333 6.61726L1.99997 6.17638C1.74692 5.97076 1.67925 5.61199 1.83997 5.32802L2.6133 3.99203C2.776 3.71951 3.10767 3.59942 3.40664 3.70479L4.0733 3.94527C4.46673 4.0926 4.90644 4.04557 5.25997 3.81835C5.41669 3.70986 5.58164 3.61382 5.7533 3.53111C6.1182 3.33204 6.36963 2.9739 6.4333 2.56251L6.54664 1.89452C6.59946 1.56783 6.88304 1.32914 7.2133 1.3334H8.74664C9.0769 1.32914 9.36049 1.56783 9.4133 1.89452L9.52664 2.56251C9.59612 2.97917 9.85817 3.33835 10.2333 3.53111C10.405 3.61382 10.5699 3.70986 10.7266 3.81835C11.0802 4.04557 11.5199 4.0926 11.9133 3.94527L12.58 3.70479C12.8828 3.59205 13.2227 3.71309 13.3866 3.99203L14.16 5.32802C14.3207 5.61199 14.253 5.97076 14 6.17638L13.4666 6.61726C13.1433 6.88622 12.9654 7.29221 12.9866 7.71277V8.00001V8.28725C12.9654 8.70781 13.1433 9.1138 13.4666 9.38276ZM5.99996 8.00001C5.99996 9.10678 6.89539 10.004 7.99996 10.004C8.53039 10.004 9.0391 9.79286 9.41417 9.41704C9.78924 9.04122 9.99996 8.5315 9.99996 8.00001C9.99996 6.89323 9.10453 5.99602 7.99996 5.99602C6.89539 5.99602 5.99996 6.89323 5.99996 8.00001Z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "market_dynamics",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.065 51.703C3.651 46.347 1 39.482 1 32C1 14.879 14.879 1 32 1C49.121 1 63 14.879 63 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 63C24.512 63 17.643 60.345 12.285 55.924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.912 53.049C44.284 56.771 38.402 59 32 59C26.875 59 22.083 57.572 18.002 55.093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.088 22C58.321 25.094 59 28.467 59 32C59 38.375 56.79 44.234 53.096 48.854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 5C38.442 5 44.357 7.256 48.998 11.021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.911 46.005C6.429 41.922 5 37.128 5 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.524 11.036C25.414 9.729 28.622 9 32 9C44.703 9 55 19.297 55 32C55 35.73 54.111 39.255 52.535 42.371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.437 52.503C39.305 54.1 35.758 55 32 55C19.297 55 9 44.703 9 32C9 27.884 10.081 24.02 11.976 20.677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.377 16.244C24.409 14.196 28.065 13 32 13C39.801 13 46.504 17.701 49.43 24.426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.968 38.004C13.34 36.117 13 34.099 13 32C13 27.574 14.513 23.503 17.05 20.272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.672 38.993C46.886 46.025 40.023 51 32 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.703 34.984C45.319 41.84 39.262 47 32 47C23.716 47 17 40.284 17 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 17C39.248 17 45.296 22.142 46.695 28.977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 39C35.866 39 39 35.866 39 32C39 28.134 35.866 25 32 25C28.134 25 25 28.134 25 32C25 35.866 28.134 39 32 39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 57C11.6569 57 13 55.6569 13 54C13 52.3431 11.6569 51 10 51C8.34315 51 7 52.3431 7 54C7 55.6569 8.34315 57 10 57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 35C48.6569 35 50 33.6569 50 32C50 30.3431 48.6569 29 47 29C45.3431 29 44 30.3431 44 32C44 33.6569 45.3431 35 47 35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 54C52.6569 54 54 52.6569 54 51C54 49.3431 52.6569 48 51 48C49.3431 48 48 49.3431 48 51C48 52.6569 49.3431 54 51 54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21C20.6569 21 22 19.6569 22 18C22 16.3431 20.6569 15 19 15C17.3431 15 16 16.3431 16 18C16 19.6569 17.3431 21 19 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 33C32.5523 33 33 32.5523 33 32C33 31.4477 32.5523 31 32 31C31.4477 31 31 31.4477 31 32C31 32.5523 31.4477 33 32 33Z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "market_performance",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60 12H12v6h48v-6Zm3 30v-6l-3-15H12L9 36v6h3v18h30V42h12v18h6V42h3ZM36 54H18V42h18v12Z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "asc",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17H22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7H18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8L5 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5L8.4641 9.5H1.5359L5 5Z",
    fill: "currentColor",
    strokeWidth: 0
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "desc",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17H18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7H22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5V16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19L1.5359 14.5L8.4641 14.5L5 19Z",
    fill: "currentColor",
    strokeWidth: 0
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 12.6667V3.33333",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8H12.6673",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus_small",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 17V7M7 12h10"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 8H12.6663",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "gender",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.05c.94 0 1.75-.34 2.42-1.02.67-.68 1-1.5 1-2.47a3.4 3.4 0 0 0-1-2.46A3.27 3.27 0 0 0 12 8.07c-.94 0-1.75.34-2.42 1.03-.67.68-1 1.5-1 2.46s.33 1.79 1 2.47A3.27 3.27 0 0 0 12 15.05Zm-.64 6.55v-1.75H9.64v-1.3h1.72v-2.2a4.83 4.83 0 0 1-4.07-4.79 5.01 5.01 0 0 1 .94-2.9l-.9-.91-1.2 1.22-.9-.92 1.2-1.22-2.14-2.18V7.2H3V2.4h4.71v1.3h-2.5l2.14 2.2 1.2-1.23.9.92-1.2 1.22.92.94A4.74 4.74 0 0 1 12 6.76a4.76 4.76 0 0 1 2.85.96l3.94-4.01h-2.5V2.4H21v4.8h-1.29V4.65l-3.94 4.01a4.64 4.64 0 0 1 .94 2.9 4.83 4.83 0 0 1-4.07 4.78v2.2h1.72v1.31h-1.72v1.75h-1.28Z",
    fill: "currentColor"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "income",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.03 18.93h1.5v-1.3a4.12 4.12 0 0 0 2.28-.94c.58-.51.87-1.21.87-2.11 0-.8-.23-1.48-.68-2.03a6.01 6.01 0 0 0-2.42-1.53 9.55 9.55 0 0 1-2.1-1 1.4 1.4 0 0 1-.63-1.2c0-.48.18-.86.53-1.14.35-.29.84-.43 1.47-.43.52 0 .95.12 1.29.36.34.24.62.58.84 1.01l1.32-.6a3.51 3.51 0 0 0-1.09-1.42 3.02 3.02 0 0 0-1.63-.62V4.7h-1.5v1.28c-.85.13-1.52.46-2 .98a2.66 2.66 0 0 0-.73 1.87c0 .81.24 1.46.73 1.95.48.48 1.22.91 2.22 1.3 1.1.45 1.85.85 2.26 1.2.41.35.62.78.62 1.3 0 .55-.22.97-.64 1.27-.43.3-.95.45-1.56.45a2.7 2.7 0 0 1-1.65-.54 2.87 2.87 0 0 1-1.03-1.51l-1.4.5a4.2 4.2 0 0 0 3.12 2.82v1.36Zm.77 2.87a10.14 10.14 0 0 1-9.21-6.13 9.67 9.67 0 0 1-.79-3.87 9.99 9.99 0 0 1 10-10 10.1 10.1 0 0 1 9.21 6.1c.53 1.22.79 2.52.79 3.9 0 1.37-.26 2.66-.79 3.88a9.99 9.99 0 0 1-9.21 6.13Z",
    fill: "currentColor"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "ethnicity",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM18.92 11H16.35C16.2943 9.1973 15.8937 7.42197 15.17 5.77C17.1948 6.80134 18.593 8.75135 18.92 11ZM12 19H12.45C13.36 18.41 14.41 16.22 14.59 13H9.41C9.55 16.24 10.64 18.43 11.55 19H12ZM9.45 11C9.63 7.78 10.68 5.59 11.59 5H12H12.45C13.36 5.57 14.45 7.76 14.59 11H9.45ZM7.65 11C7.70571 9.1973 8.10626 7.42197 8.83 5.77C6.80522 6.80134 5.40704 8.75135 5.08 11H7.65ZM5.08 13H7.65C7.70571 14.8027 8.10626 16.578 8.83 18.23C6.80522 17.1987 5.40704 15.2487 5.08 13ZM16.35 13C16.2943 14.8027 15.8937 16.578 15.17 18.23C17.1948 17.1987 18.593 15.2487 18.92 13H16.35Z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "relationship",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95 21.8v-7.5H3.6V8.68c0-.52.19-.96.56-1.33.38-.37.81-.55 1.31-.55h2.76c.5 0 .93.18 1.3.55.36.37.55.8.55 1.33v5.62H8.75v7.5h-3.8Zm1.9-16.22c-.52 0-.96-.2-1.34-.57a1.83 1.83 0 0 1-.56-1.34c0-.51.19-.95.56-1.32.38-.37.82-.55 1.34-.55.52 0 .96.18 1.32.55.37.37.56.8.56 1.32s-.19.97-.56 1.34c-.36.38-.8.57-1.32.57Zm8.22 16.22v-6h-2.72l2.28-7.72c.11-.42.34-.74.68-.96.34-.21.73-.32 1.17-.32.43 0 .82.1 1.16.32.34.22.57.54.69.96l2.27 7.72h-2.72v6h-2.8Zm1.4-16.22c-.51 0-.95-.2-1.32-.57a1.85 1.85 0 0 1-.55-1.34c0-.51.18-.95.55-1.32.37-.37.8-.55 1.33-.55.51 0 .95.18 1.32.55.37.37.55.8.55 1.32s-.18.97-.55 1.34c-.37.38-.8.57-1.32.57Z",
    fill: "currentColor"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "education",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.52 16.95v-7L12.17 15 1.2 9l10.97-6L23.2 9v7.95h-1.68ZM12.17 21l-7.15-3.93v-5.14l7.15 3.9 7.18-3.9v5.14L12.17 21Z",
    fill: "currentColor"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "hispanic",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21.8V8.42a6.5 6.5 0 0 1-3.74-2.26A6.1 6.1 0 0 1 3.6 2.2h1.65c0 1.33.49 2.45 1.46 3.36.98.91 2.17 1.37 3.59 1.37h2.5a4 4 0 0 1 1.41.2c.34.13.73.39 1.17.77l4.57 4.38-1.2 1.2-4.4-4.23V21.8H12.7v-6.25h-2.27v6.25H8.75Zm2.8-16.23c-.52 0-.96-.18-1.32-.56a1.85 1.85 0 0 1-.55-1.34c0-.51.18-.95.55-1.32.36-.37.8-.55 1.32-.55s.96.18 1.34.55c.37.37.56.8.56 1.32s-.19.97-.56 1.34c-.38.38-.82.57-1.34.57Z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "age",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21.8a.97.97 0 0 1-.71-.29.97.97 0 0 1-.29-.71v-4.98c0-.46.16-.86.49-1.18.32-.33.72-.49 1.19-.49h14.64c.47 0 .87.16 1.2.49.32.32.48.72.48 1.18v4.98c0 .28-.1.52-.29.71-.19.2-.43.29-.71.29H4Zm1.13-9.32V9.45c0-.47.16-.86.48-1.19.33-.32.72-.48 1.17-.48h4.4V6.22a2.49 2.49 0 0 1-.77-.73 1.85 1.85 0 0 1-.26-1.01 1.87 1.87 0 0 1 .55-1.33L12 1.8l1.3 1.35c.18.18.32.39.42.61.1.23.15.47.15.72 0 .4-.09.73-.27 1-.18.28-.44.53-.78.74v1.56h4.4c.45 0 .84.16 1.17.48.32.33.48.72.48 1.19v3.03H5.13Z",
    fill: "currentColor"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "employment",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7H17V5C17 3.89543 16.1046 3 15 3H9C7.89543 3 7 3.89543 7 5V7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7ZM14 14C14 14.5523 13.5523 15 13 15H11C10.4477 15 10 14.5523 10 14V13.5C10 13.2239 10.2239 13 10.5 13H13.5C13.7761 13 14 13.2239 14 13.5V14ZM9 7H15V5H9V7Z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "household_size",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21V7.08h4.08V3h9.84v8.18H21V21h-7.77v-4.08h-2.46V21H3Zm1.68-1.68h2.4v-2.4h-2.4v2.4Zm0-4.07h2.4v-2.43h-2.4v2.43Zm0-4.07h2.4V8.75h-2.4v2.43Zm4.07 4.07h2.43v-2.43H8.75v2.43Zm0-4.07h2.43V8.75H8.75v2.43Zm0-4.1h2.43v-2.4H8.75v2.4Zm4.07 8.17h2.43v-2.43h-2.43v2.43Zm0-4.07h2.43V8.75h-2.43v2.43Zm0-4.1h2.43v-2.4h-2.43v2.4Zm4.1 12.24h2.4v-2.4h-2.4v2.4Zm0-4.07h2.4v-2.43h-2.4v2.43Z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "restaurant_wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08 22v-9.17a4.03 4.03 0 0 1-2.18-1.35C4.3 10.78 4 9.95 4 9V2h1.67v7h1.4V2h1.68v7h1.42V2h1.65v7c0 .95-.3 1.78-.88 2.48-.6.7-1.32 1.15-2.19 1.35V22H7.08Zm10.24 0v-8h-2.9V6.58A4.45 4.45 0 0 1 19 2v20h-1.67Z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "customer_segments",
    viewBox: "0 0 25 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1223 8.79501C10.1223 8.66169 10.0684 8.53389 9.97259 8.44001L6.77316 5.27001L8.21088 3.85001C8.35395 3.70586 8.39522 3.49088 8.31551 3.305C8.23581 3.11913 8.05076 2.99882 7.84639 3.00001H3.54336C3.26819 3.01028 3.04751 3.22823 3.03712 3.50001V7.75001C3.03587 7.95447 3.16078 8.13907 3.35252 8.21615C3.54426 8.29322 3.76419 8.24722 3.90785 8.10001L5.34557 6.68001L8.545 9.85001C8.64005 9.94466 8.76944 9.99791 8.90443 9.99791C9.03941 9.99791 9.1688 9.94466 9.26386 9.85001L9.97259 9.15001C10.0684 9.05613 10.1223 8.92833 10.1223 8.79501ZM8.90443 14.0021C9.03941 14.0021 9.1688 14.0554 9.26386 14.15L9.97259 14.85C10.0684 14.9439 10.1223 15.0717 10.1223 15.205C10.1223 15.3383 10.0684 15.4661 9.97259 15.56L6.76304 18.72L8.20075 20.15C8.34256 20.2929 8.38451 20.5054 8.30738 20.6904C8.23026 20.8754 8.04892 20.9972 7.84639 21H3.54336C3.26819 20.9897 3.04751 20.7718 3.03712 20.5V16.25C3.03592 16.0482 3.15773 15.8654 3.34592 15.7867C3.53411 15.7079 3.75177 15.7487 3.89772 15.89L5.33544 17.31L8.545 14.15C8.64005 14.0554 8.76944 14.0021 8.90443 14.0021ZM20.4011 15.9L18.9634 17.32L15.764 14.15C15.6689 14.0554 15.5395 14.0021 15.4045 14.0021C15.2695 14.0021 15.1402 14.0554 15.0451 14.15L14.3364 14.85C14.2405 14.9439 14.1866 15.0717 14.1866 15.205C14.1866 15.3383 14.2405 15.4661 14.3364 15.56L17.5358 18.73L16.0981 20.15C15.955 20.2942 15.9137 20.5091 15.9934 20.695C16.0731 20.8809 16.2582 21.0012 16.4626 21H20.7555C21.0306 20.9897 21.2513 20.7718 21.2617 20.5V16.25C21.263 16.0456 21.1381 15.8609 20.9463 15.7839C20.7546 15.7068 20.5346 15.7528 20.391 15.9H20.4011ZM16.4524 3.00001H20.7555C21.0306 3.01028 21.2513 3.22823 21.2617 3.50001V7.75001C21.2629 7.95186 21.1411 8.13463 20.9529 8.21335C20.7647 8.29208 20.5471 8.25131 20.4011 8.11001L18.9634 6.69001L15.7538 9.85001C15.6588 9.94466 15.5294 9.99791 15.3944 9.99791C15.2594 9.99791 15.13 9.94466 15.035 9.85001L14.3262 9.15001C14.2304 9.05613 14.1765 8.92833 14.1765 8.79501C14.1765 8.66169 14.2304 8.53389 14.3262 8.44001L17.5358 5.27001L16.0981 3.85001C15.9563 3.70716 15.9143 3.49457 15.9914 3.30958C16.0686 3.1246 16.2499 3.00282 16.4524 3.00001Z"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "category_wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H19C19 3.89543 18.1046 3 17 3H6C4.34315 3 3 4.34315 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7ZM5 19V9H19V11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H19V19H5ZM15 14.5V13.5C15 13.2239 14.7761 13 14.5 13H13.5C13.2239 13 13 13.2239 13 13.5V14.5C13 14.7761 13.2239 15 13.5 15H14.5C14.7761 15 15 14.7761 15 14.5Z"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross-category_wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H19C19 3.89543 18.1046 3 17 3H6C4.34315 3 3 4.34315 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7ZM5 19V9H19V11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H19V19H5ZM15 14.5V13.5C15 13.2239 14.7761 13 14.5 13H13.5C13.2239 13 13 13.2239 13 13.5V14.5C13 14.7761 13.2239 15 13.5 15H14.5C14.7761 15 15 14.7761 15 14.5Z"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "segment",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9598 10.949H21.9998C21.5288 6.232 17.7678 2.471 13.0508 2V6.04C15.5578 6.463 17.5368 8.442 17.9598 10.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0508 17.949C8.74178 17.949 6.05078 15.258 6.05078 11.949C6.05078 8.982 8.21778 6.517 11.0508 6.04V2C6.00478 2.504 2.05078 6.773 2.05078 11.949C2.05078 17.463 6.53678 21.949 12.0508 21.949C17.2268 21.949 21.4958 17.995 21.9998 12.949H17.9598C17.4818 15.782 15.0178 17.949 12.0508 17.949Z"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "market",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3V20C3 20.553 3.447 21 4 21H21V19H5V3H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7702 14.0984C15.15 14.4702 15.7638 14.4702 16.1436 14.0984L21 9.34443L19.6266 8L15.4569 12.0818L13.2298 9.90159C12.85 9.52983 12.2362 9.52983 11.8564 9.90159L7 14.6556L8.37339 16L12.5431 11.9182L14.7702 14.0984Z"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "brand",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03 8.32 11.67 3h.66l2.64 5.32H9.03Zm2.3 11.88L2.54 9.68h8.77V20.2Zm1.34 0V9.68h8.78L12.67 20.2Zm3.78-11.88L13.83 3H19l2.65 5.32h-5.2Zm-14.1 0L5 3h5.17L7.55 8.32h-5.2Z"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H19C19 3.89543 18.1046 3 17 3H6C4.34315 3 3 4.34315 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7ZM5 19V9H19V11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H19V19H5ZM15 14.5V13.5C15 13.2239 14.7761 13 14.5 13H13.5C13.2239 13 13 13.2239 13 13.5V14.5C13 14.7761 13.2239 15 13.5 15H14.5C14.7761 15 15 14.7761 15 14.5Z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "categories",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16 17.1435 15.2625 15.363 13.9497 14.0503C12.637 12.7375 10.8565 12 9 12C7.14349 12 5.36301 12.7375 4.05025 14.0503C2.7375 15.363 2 17.1435 2 19L9 19H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1338 13.5122C17.3376 15.0769 18.0004 17.0043 18.0004 19H22.0004C22.0004 17.5413 21.421 16.1424 20.3895 15.1109C19.3581 14.0795 17.9591 13.5 16.5004 13.5C16.3777 13.5 16.2555 13.5041 16.1338 13.5122Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 2.5
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.039 23.974l-3.332-2.606c.044-.401.078-.871.078-1.368 0-.497-.036-.967-.078-1.368l3.335-2.607c.62-.49.79-1.358.394-2.082l-3.465-5.995c-.379-.69-1.23-1.006-2.004-.72l-3.932 1.578a13.411 13.411 0 00-2.359-1.37l-.598-4.17a1.604 1.604 0 00-1.601-1.391h-6.948c-.814 0-1.503.598-1.6 1.376l-.6 4.185c-.79.358-1.569.81-2.356 1.372L8.031 7.225a1.606 1.606 0 00-1.989.708l-3.47 6.004a1.62 1.62 0 00.393 2.09l3.332 2.605c-.053.51-.078.953-.078 1.368 0 .416.026.858.075 1.369L2.96 23.977c-.617.49-.787 1.358-.392 2.081l3.465 5.995c.376.689 1.224 1.003 2.004.72l3.931-1.578a13.613 13.613 0 002.361 1.37l.598 4.169a1.604 1.604 0 001.601 1.391h6.948c.814 0 1.503-.598 1.6-1.376l.6-4.184c.79-.358 1.569-.81 2.356-1.371l3.942 1.583c.75.291 1.611-.017 1.99-.709l3.482-6.025a1.633 1.633 0 00-.406-2.07zm-.914 1.329l-3.598 6.069-4.324-1.737a.758.758 0 00-.734.097c-.937.7-1.841 1.227-2.769 1.607a.754.754 0 00-.462.592l-.763 4.684-7.049-.08-.66-4.603a.758.758 0 00-.462-.592 12.037 12.037 0 01-2.763-1.602.752.752 0 00-.743-.103L7.35 31.313l-3.465-5.995c-.032-.059-.026-.127.01-.155l3.666-2.866a.757.757 0 00.284-.689A12.742 12.742 0 017.73 20c0-.464.038-.974.116-1.609a.755.755 0 00-.284-.688l-3.683-3.005L7.476 8.63l4.324 1.737c.246.1.522.061.735-.097.935-.702 1.841-1.228 2.769-1.607a.758.758 0 00.46-.592l.765-4.686 7.05.082.66 4.604c.038.266.213.49.461.592a11.99 11.99 0 012.763 1.602.75.75 0 00.741.102l4.449-1.678 3.465 5.994c.031.06.025.126-.01.154l-3.667 2.866a.755.755 0 00-.284.688c.058.46.117 1.01.117 1.609 0 .6-.06 1.15-.117 1.609a.757.757 0 00.284.688l3.661 2.864c.04.032.047.1.023.142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001 12.448c-4.164 0-7.552 3.388-7.552 7.552s3.388 7.552 7.552 7.552c4.165 0 7.552-3.388 7.552-7.552s-3.387-7.552-7.552-7.552zm0 13.594A6.048 6.048 0 0113.96 20 6.048 6.048 0 0120 13.958 6.048 6.048 0 0126.043 20a6.048 6.048 0 01-6.042 6.042z"
  })))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_green",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20l6 6 11-11",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "hamb",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 7V5h18v2H3zm0 6h18v-2H3v2zm0 6h18v-2H3v2z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "fullscreen",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "minimaze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19h2v-5H5v2h3v3ZM16 16h3v-2h-5v5h2v-3ZM19 10V8h-3V5h-2v5h5ZM10 5H8v3H5v2h5V5Z"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "brand_sample",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16 17.1435 15.2625 15.363 13.9497 14.0503C12.637 12.7375 10.8565 12 9 12C7.14349 12 5.36301 12.7375 4.05025 14.0503C2.7375 15.363 2 17.1435 2 19L9 19H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1334 13.5122C17.3372 15.0769 18.0001 17.0043 18.0001 19H22.0001C22.0001 17.5413 21.4206 16.1424 20.3891 15.1109C19.3577 14.0795 17.9587 13.5 16.5001 13.5C16.3774 13.5 16.2551 13.5041 16.1334 13.5122Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 2.5
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "geo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.383 17.5458 17.1267 12.6462 21.4399C12.2772 21.7648 11.7228 21.7648 11.3538 21.4399C6.45419 17.1267 4 13.383 4 10.2C4 5.22 7.8 2 12 2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "channel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7.22089C3 8.07525 3.34728 8.89448 3.96572 9.49844C4.58397 10.1024 5.42258 10.4418 6.29715 10.4418H6.49494L7.85871 15.2438C7.18716 15.7577 6.7458 16.5059 6.62703 17.331C6.50849 18.1563 6.72174 18.9943 7.22227 19.6692C7.7228 20.3438 8.4715 20.803 9.31134 20.9496C10.151 21.0964 11.0162 20.9196 11.7251 20.4563C12.4341 19.9929 12.9317 19.2793 13.1134 18.465C13.2951 17.6509 13.1467 16.7995 12.6993 16.09L16.1881 12.4212C16.9809 12.8217 17.9059 12.8911 18.752 12.6138C19.5979 12.3364 20.2929 11.7357 20.6776 10.9492C21.0625 10.1626 21.1046 9.25724 20.7941 8.43985C20.4836 7.62245 19.8472 6.96296 19.0303 6.61207C18.2134 6.26098 17.2858 6.24852 16.4593 6.57735C15.6329 6.90618 14.978 7.54831 14.6446 8.35713L9.59413 7.26481V7.2209C9.59413 6.07018 8.96587 5.00688 7.94556 4.43152C6.92545 3.85616 5.66872 3.85616 4.64862 4.43152C3.62852 5.00688 3.00004 6.07018 3.00004 7.2209L3 7.22089ZM9.89382 19.2259C9.49637 19.2259 9.11521 19.0717 8.834 18.797C8.553 18.5224 8.39515 18.1501 8.39515 17.7618C8.39515 17.3736 8.553 17.0012 8.834 16.7265C9.11521 16.452 9.49635 16.2978 9.89382 16.2978C10.2913 16.2978 10.6724 16.452 10.9534 16.7265C11.2346 17.0012 11.3925 17.3736 11.3925 17.7618C11.3925 18.1501 11.2346 18.5224 10.9534 18.797C10.6724 19.0717 10.2913 19.2259 9.89382 19.2259ZM17.6868 8.09931C18.0843 8.09931 18.4657 8.25351 18.7467 8.52801C19.0276 8.80272 19.1855 9.17506 19.1855 9.56334C19.1855 9.95162 19.0276 10.3239 18.7467 10.5987C18.4657 10.8732 18.0843 11.0274 17.6868 11.0274C17.2894 11.0274 16.9082 10.8732 16.6272 10.5987C16.3462 10.324 16.1882 9.95162 16.1882 9.56334C16.1882 9.17506 16.3462 8.80273 16.6272 8.52801C16.9082 8.25351 17.2894 8.09931 17.6868 8.09931ZM14.4409 10.1168C14.5103 10.5071 14.6537 10.8815 14.8634 11.2205L11.3775 14.8894C10.918 14.6606 10.4097 14.5414 9.8939 14.5409C9.77368 14.5413 9.65367 14.5483 9.53408 14.5616L8.19433 9.85621C8.5437 9.61458 8.84186 9.30924 9.07265 8.95714L14.4409 10.1168ZM6.29731 5.75682C6.69477 5.75682 7.07592 5.91102 7.35692 6.18573C7.63791 6.46023 7.79597 6.83257 7.79597 7.22085C7.79597 7.60913 7.63791 7.98146 7.35692 8.25617C7.07592 8.53067 6.69478 8.68488 6.29731 8.68488C5.89986 8.68488 5.51849 8.53067 5.23749 8.25617C4.9565 7.98146 4.79864 7.60913 4.79864 7.22085C4.79864 6.83257 4.9565 6.46023 5.23749 6.18573C5.51849 5.91102 5.89985 5.75682 6.29731 5.75682Z",
    fill: "currentColor"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "buyer_status",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.75C8.31 11.75 7.75 12.31 7.75 13C7.75 13.69 8.31 14.25 9 14.25C9.69 14.25 10.25 13.69 10.25 13C10.25 12.31 9.69 11.75 9 11.75ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 11.71 4.02 11.42 4.05 11.14C6.41 10.09 8.28 8.16 9.26 5.77C11.07 8.33 14.05 10 17.42 10C18.2 10 18.95 9.91 19.67 9.74C19.88 10.45 20 11.21 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "date_header",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4V1",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4V1",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11H7V13H9V11ZM9 15H7V17H9V15ZM11 11H13V13H11V11ZM13 15H11V17H13V15ZM15 11H17V13H15V11ZM17 15H15V17H17V15Z"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "benchmark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7H11V17H13V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10H15V17H17V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12H7V17H9V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19V5C3 3.897 3.897 3 5 3H19C20.103 3 21 3.897 21 5V19C21 20.103 20.103 21 19 21H5C3.897 21 3 20.103 3 19ZM5 19H19.001L19 5H5V19Z"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 21.0003C15.3463 20.9988 13.7183 20.5901 12.26 19.8103L11.81 19.5603C8.70075 17.8886 6.15169 15.3395 4.48 12.2303L4.23 11.7803C3.42982 10.3136 3.00713 8.67097 3 7.00027V6.33027C2.99958 5.79723 3.21196 5.28607 3.59 4.91027L5.28 3.22027C5.44413 3.05487 5.67581 2.97514 5.90696 3.00453C6.13811 3.03391 6.34248 3.16906 6.46 3.37027L8.71 7.23027C8.93753 7.62316 8.87183 8.12002 8.55 8.44027L6.66 10.3303C6.50304 10.4855 6.46647 10.7253 6.57 10.9203L6.92 11.5803C8.17704 13.9087 10.0893 15.8175 12.42 17.0703L13.08 17.4303C13.275 17.5338 13.5148 17.4972 13.67 17.3403L15.56 15.4503C15.8802 15.1284 16.3771 15.0627 16.77 15.2903L20.63 17.5403C20.8312 17.6578 20.9664 17.8622 20.9957 18.0933C21.0251 18.3245 20.9454 18.5561 20.78 18.7203L19.09 20.4103C18.7142 20.7883 18.203 21.0007 17.67 21.0003H17Z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1.94971C6.48024 1.94971 2.00024 6.42971 2.00024 11.9497C2.00024 17.4697 6.48024 21.9497 12.0002 21.9497H17.0002V19.9497H12.0002C7.66024 19.9497 4.00024 16.2897 4.00024 11.9497C4.00024 7.60971 7.66024 3.94971 12.0002 3.94971C16.3402 3.94971 20.0002 7.60971 20.0002 11.9497V13.3797C20.0002 14.1697 19.2902 14.9497 18.5002 14.9497C17.7102 14.9497 17.0002 14.1697 17.0002 13.3797V11.9497C17.0002 9.18971 14.7602 6.94971 12.0002 6.94971C9.24024 6.94971 7.00024 9.18971 7.00024 11.9497C7.00024 14.7097 9.24024 16.9497 12.0002 16.9497C13.3802 16.9497 14.6402 16.3897 15.5402 15.4797C16.1902 16.3697 17.3102 16.9497 18.5002 16.9497C20.4702 16.9497 22.0002 15.3497 22.0002 13.3797V11.9497C22.0002 6.42971 17.5202 1.94971 12.0002 1.94971ZM12.0002 14.9497C10.3402 14.9497 9.00024 13.6097 9.00024 11.9497C9.00024 10.2897 10.3402 8.94971 12.0002 8.94971C13.6602 8.94971 15.0002 10.2897 15.0002 11.9497C15.0002 13.6097 13.6602 14.9497 12.0002 14.9497Z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5V2",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5V2",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 4,
    height: 4,
    fill: "currentColor"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye_open",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7833 11.2155L19.9056 11.6947L20.7833 11.2155ZM20.7833 12.7845L19.9056 12.3054L20.7833 12.7845ZM4.09443 11.6946C5.6225 8.89537 8.59063 7 12 7V5C7.82999 5 4.20347 7.32074 2.33895 10.7364L4.09443 11.6946ZM12 7C15.4094 7 18.3775 8.89538 19.9056 11.6947L21.661 10.7364C19.7965 7.32075 16.17 5 12 5V7ZM19.9056 12.3054C18.3775 15.1046 15.4094 17 12 17V19C16.17 19 19.7965 16.6793 21.661 13.2636L19.9056 12.3054ZM12 17C8.59063 17 5.6225 15.1046 4.09443 12.3053L2.33895 13.2636C4.20347 16.6793 7.82999 19 12 19V17ZM19.9056 11.6947C20.0095 11.885 20.0095 12.115 19.9056 12.3054L21.661 13.2636C22.091 12.476 22.091 11.524 21.661 10.7364L19.9056 11.6947ZM2.33895 10.7364C1.90899 11.524 1.90899 12.476 2.33895 13.2636L4.09443 12.3053C3.9905 12.115 3.9905 11.885 4.09443 11.6946L2.33895 10.7364Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_view_briefing",
    viewBox: "0 0 256 86",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDF4EC",
    fillRule: "evenodd",
    d: "M121.628 43.0206c-3.947-3.4184-9.65-3.5564-14.851-3.0984-.586.0515-1.178.0778-1.777.0778-2.895 0-5.6459-.615-8.1299-1.7215-5.0952-2.2696-10.718-4.4954-16.0755-2.9432l-2.0817.6031C71.4338 38.0473 68 46.4216 68 54c0 17.6731-14.3269 32-32 32C18.3269 86 4 71.6731 4 54c0-17.6731 14.3269-32 32-32 5.344 0 10.382 1.3099 14.8104 3.6262 5.8293 3.049 12.4735 5.2968 18.7922 3.4661l11.558-3.3486C83.5987 25.0373 85 22.5384 85 20c0-11.0457 8.9543-20 20-20 11.046 0 20 8.9543 20 20 0 .1125-.001.2247-.003.3368-.093 5.6683.594 11.9564 4.879 15.6678 4.075 3.5286 9.981 3.5752 15.26 2.4885C146.707 38.1698 148.334 38 150 38c5.004 0 9.65 1.5315 13.496 4.1512 3.849 2.622 8.661 4.2555 13.012 2.5952l2.581-.9849C182.213 42.5693 184 39.344 184 36c0-19.8823 16.118-36 36-36s36 16.1177 36 36-16.118 36-36 36c-7.195 0-13.896-2.1105-19.52-5.7461-5.553-3.5905-12.392-5.7375-18.57-3.3799-5.109 1.9492-8.475 6.6848-11.272 11.3831C166.453 81.2887 158.777 86 150 86c-13.255 0-24-10.7452-24-24 0-.8905.049-1.7697.143-2.635.643-5.8914-.035-12.4646-4.515-16.3444Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M33 15v-3h42v48c0 2.209-1.791 4-4 4s-4-1.791-4-4V22c0-2.209-1.791-4-4-4m0 0c-2.209 0-4 1.791-4 4v47l-1 1-4 4-4-4-4 4-4-4-4 4-4-4-4 4-4-4-4 4-4-4-1-1V22c0-2.209 1.791-4 4-4h42ZM71 64h-9M27 64h-2M31 64h-2M35 64h-2M39 64h-2M43 64h-2M47 64h-2M51 64h-2M55 64h-2M29 24h8M29 28h26M26 61V43M23 64h-2M22 61V43M30 61v-8M38 61V41M34 61V47M42 61V49M46 61V43M50 61V51M54 61V39M39 24h16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26 24h-4v4h4v-4ZM132 54v18M142 54l6 17v1M122 54l-6 17v1M159 25v29h-54V25M101 22v-4h24l2-4h10l2 4h24v4h-62ZM129 18h6M100 72h64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M126 32c.552 0 1-.4477 1-1s-.448-1-1-1-1 .4477-1 1 .448 1 1 1ZM136 46c.552 0 1-.4477 1-1s-.448-1-1-1-1 .4477-1 1 .448 1 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M131 33v-2c0-2.762-2.238-5-5-5s-5 2.238-5 5v6c0 2.762-2.238 5-5 5h-6M154 34h-8c-2.762 0-5 2.238-5 5v6c0 2.762-2.238 5-5 5s-5-2.238-5-5v-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m150 38 4-4-4-4M131 35v2M131 39v2M108 26h2M154 26h2M154 50h2M108 50h2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M209 75v-9M219 66v9M222 61v4c0 .553-.447 1-1 1h-14c-.553 0-1-.447-1-1v-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M214 62c13.807 0 25-11.1929 25-25s-11.193-25-25-25-25 11.1929-25 25 11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M219 31.5c0 3.5-1.963 6.5-5 6.5s-5-3-5-6.5 1-5.5 5-5.5 5 2 5 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m217 37 7 4v2c0 1.656-1 3-2 3h-16c-1 0-2-1.344-2-3v-2l7-4M214 69v6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M214 58c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M198 37c0-8.837 7.164-16 16-16"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_view_report",
    viewBox: "0 0 256 86",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDF4EC",
    fillRule: "evenodd",
    d: "M94 41c.774 0 1.5359-.0517 2.2825-.1519 5.2355-.7025 10.9945-1.4445 15.4475 1.3957l1.844 1.1761C117.633 46.0088 119 51.1856 119 56c0 11.598 9.178 21 20.5 21 5.63 0 10.729-2.3245 14.434-6.0878 3.572-3.6283 7.493-7.3366 12.499-8.2679l2.777-.5167c5.09-.947 10.175 1.0294 14.533 3.8253C188.723 69.1475 194.645 71 201 71c17.673 0 32-14.3269 32-32 0-17.6731-14.327-32-32-32-13.691 0-25.374 8.598-29.944 20.6891-2.056 5.4401-6.049 10.4234-11.766 11.4871-3.875.7208-7.764-.6548-11.338-2.314C145.375 35.666 142.513 35 139.5 35c-2.995 0-5.84.658-8.405 1.8405-4.535 2.0908-10.008 3.1945-14.219.5092l-.749-.4778C112.05 34.2718 111 28.8354 111 24c0-9.3888-7.611-17-17-17-9.3888 0-17 7.6112-17 17 0 2.784-.9682 5.6557-3.3155 7.1528l-2.2459 1.4324c-4.1553 2.6502-9.5521 1.5949-13.8784-.7663C54.264 30.0199 50.4986 29 46.5 29 33.5213 29 23 39.7452 23 53s10.5213 24 23.5 24S70 66.2548 70 53c0-.9086-.0494-1.8053-.1457-2.6876-.4721-4.3265.7461-9.0162 4.4154-11.3565 3.7489-2.391 8.6468-1.3186 12.6935.5239C89.1075 40.4561 91.4902 41 94 41Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36AD86",
    fillRule: "evenodd",
    d: "M10.25 12.25c-.2477.2477-.25.4166-.25 18.75s.0023 18.5023.25 18.75c.2461.2461.4221.2501 11.2188.258l10.9687.0079.55 1.1413c.4444.9224.7446 1.3388 1.5649 2.1702l1.015 1.0289-.2113.8368c-.1161.4603-.2579.8794-.3148.9313-.1799.1636-8.4523 2.85-9.0264 2.9314-1.374.1943-2.9014 1.3606-3.5671 2.7236-.3213.6575-.395 1.1081-.8894 5.4375-.2965 2.5963-.5434 4.7347-.5488 4.7519-.0052.0171-1.2471.0312-2.7596.0312-2.5834 0-2.7651.0151-3 .25-.3393.3392-.3393 1.1608 0 1.5.2484.2484.4166.25 25.75.25s25.5016-.0016 25.75-.25c.3392-.3392.3392-1.1608 0-1.5-.2349-.2349-.4166-.25-3-.25-1.5125 0-2.7544-.0141-2.7596-.0312-.0054-.0172-.2523-2.1556-.5488-4.7519-.4943-4.3294-.5681-4.78-.8894-5.4375-.6657-1.363-2.1931-2.5293-3.5671-2.7236-.5741-.0814-8.8465-2.7678-9.0263-2.9314-.057-.0519-.1988-.471-.3149-.9313l-.2113-.8368 1.015-1.0289c.8203-.8314 1.1205-1.2478 1.5649-2.1702l.55-1.1413 10.9687-.0079c10.7967-.0079 10.9727-.0119 11.2188-.258.2477-.2477.25-.4166.25-18.75s-.0023-18.5023-.25-18.75c-.2486-.2486-.4166-.25-30.75-.25s-30.5014.0014-30.75.25ZM70 31v17H50v-3.1675c0-2.7415-.0331-3.2969-.246-4.1296-.7941-3.1048-3.3521-5.6628-6.4569-6.4569-1.306-.334-3.2882-.334-4.5942 0-1.578.4036-2.8535 1.1455-4.0825 2.3744-1.2289 1.229-1.9708 2.5045-2.3744 4.0825-.2129.8327-.246 1.3881-.246 4.1296V48H12V14h58v17ZM14.25 16.25c-.2381.2381-.25.4166-.25 3.75s.0119 3.5119.25 3.75c.2291.2291.4166.25 2.25.25s2.0209-.0209 2.25-.25c.2381-.2381.25-.4166.25-3.75s-.0119-3.5119-.25-3.75c-.2291-.2291-.4166-.25-2.25-.25s-2.0209.0209-2.25.25Zm6 0c-.1666.1666-.25.4166-.25.75s.0834.5834.25.75c.2463.2463.4166.25 11.25.25s11.0037-.0037 11.25-.25c.1666-.1666.25-.4166.25-.75s-.0834-.5834-.25-.75c-.2463-.2463-.4166-.25-11.25-.25s-11.0037.0037-11.25.25Zm36.4038.0019c-3.0707.8045-5.6201 3.3711-6.4078 6.451C50.0767 23.365 50 24.0813 50 25c0 2.5991.8086 4.5679 2.6204 6.3796C54.4321 33.1914 56.4009 34 59 34s4.5679-.8086 6.3796-2.6204C67.1914 29.5679 68 27.5991 68 25c0-.9187-.0767-1.635-.246-2.2971-.7941-3.1048-3.3521-5.6628-6.4569-6.4569-1.2856-.3288-3.3762-.3261-4.6433.0059ZM17 20v2h-1v-4h1v2Zm41 1.2825V24.44l-2.2995 2.297-2.2995 2.297-.3269-.494c-.6685-1.0101-.8801-1.8433-.8835-3.4775-.0037-1.8246.2085-2.5789 1.1019-3.9146.912-1.3635 2.3501-2.404 3.9189-2.8353.3306-.0909.6432-.1702.6948-.1765.0517-.0061.0938 1.4098.0938 3.1464Zm3.25-2.8167c2.1941.7102 3.9743 2.7412 4.5491 5.1904l.0806.3438H60v-5.8797l.3438.0817c.1889.0449.5968.1636.9062.2638Zm-41 .7842c-.1666.1666-.25.4166-.25.75s.0834.5834.25.75c.2456.2456.4166.25 9.75.25s9.5044-.0044 9.75-.25c.1666-.1666.25-.4166.25-.75s-.0834-.5834-.25-.75c-.2456-.2456-.4166-.25-9.75-.25s-9.5044.0044-9.75.25Zm0 3c-.1666.1666-.25.4166-.25.75s.0834.5834.25.75c.2424.2424.4166.25 5.75.25s5.5076-.0076 5.75-.25c.1666-.1666.25-.4166.25-.75s-.0834-.5834-.25-.75c-.2424-.2424-.4166-.25-5.75-.25s-5.5076.0076-5.75.25Zm-6 4c-.2421.2421-.25.4166-.25 5.5 0 5.1666-.004 5.25-.25 5.25-.684 0-1.032 1.218-.5 1.75.2454.2454.4166.25 9.25.25s9.0046-.0046 9.25-.25c.532-.532.184-1.75-.5-1.75-.2456 0-.25-.0834-.25-4.75 0-4.5834-.0088-4.7587-.25-5-.2291-.2291-.4166-.25-2.25-.25s-2.0209.0209-2.25.25c-.2412.2413-.25.4166-.25 5V37h-1v-3.25c0-3.0834-.0129-3.2629-.25-3.5-.2291-.2291-.4166-.25-2.25-.25s-2.0209.0209-2.25.25c-.2371.2371-.25.4166-.25 3.5V37h-1v-5.25c0-5.0834-.0079-5.2579-.25-5.5-.2291-.2291-.4166-.25-2.25-.25s-2.0209.0209-2.25.25Zm51.5769-.0312c-.0358.1203-.1042.3874-.152.5937-.4819 2.0771-2.4294 4.08-4.6358 4.768-1.8242.5688-4.1412.2969-5.5791-.6546l-.494-.3269 2.297-2.2995L59.56 26h3.1659c2.9566 0 3.1616.0145 3.101.2188ZM17 32.5V37h-1v-9h1v4.5Zm12 .5v4h-1v-8h1v4Zm-6 1.5V37h-1v-5h1v2.5Zm32.25 1.75c-.1666.1666-.25.4166-.25.75s.0834.5834.25.75c.2424.2424.4166.25 5.75.25s5.5076-.0076 5.75-.25c.1666-.1666.25-.4166.25-.75s-.0834-.5834-.25-.75c-.2424-.2424-.4166-.25-5.75-.25s-5.5076.0076-5.75.25Zm-11.9375.2283c1.6664.6062 3.1634 1.9723 3.9276 3.5842.6154 1.2981.6974 1.8786.6974 4.9375 0 3.0555-.0816 3.635-.6951 4.9375-.1944.4125-.6246 1.0856-.9561 1.4958-.5951.736-.6103.7451-1.1857.7097-.7345-.0451-1.1006.2642-1.1006.9299 0 .3699.2961 1.7598.5771 2.7083C44.6377 55.986 44.4098 56 41 56c-3.4097 0-3.6378-.014-3.5771-.2188.281-.9485.5771-2.3384.5771-2.7083 0-.6657-.3661-.975-1.1006-.9299-.5754.0354-.5906.0263-1.1856-.7097-.6659-.8238-1.2526-1.9534-1.4604-2.8118-.2033-.8396-.3012-4.7647-.1513-6.0685.1674-1.4565.5039-2.4028 1.2369-3.4779.8894-1.3042 2.316-2.3243 3.8724-2.769.9253-.2642 3.1591-.1705 4.1011.1722Zm10.1606 4.4948c-1.9233 1.9233-1.9731 1.9863-1.9731 2.5 0 .7038.3215 1.0269 1.0216 1.0269.5031 0 .5837-.0616 2.2865-1.75L56.5732 41h4.9634c4.7968 0 4.9718-.0084 5.2134-.25.1666-.1666.25-.4166.25-.75s-.0834-.5834-.25-.75c-.2425-.2425-.4166-.25-5.7769-.25h-5.527l-1.973 1.9731ZM13.25 40.25c-.1666.1666-.25.4166-.25.75s.0834.5834.25.75c.2424.2424.4166.25 5.7145.25h5.4644l2.262 2.25c2.2102 2.1985 2.274 2.25 2.7855 2.25.7026 0 1.0236-.3224 1.0236-1.0277 0-.5193-.04-.5678-2.4722-3.0001L25.5555 40h-6.0277c-5.8612 0-6.0347.0069-6.2778.25Zm0 3c-.1666.1666-.25.4166-.25.75s.0834.5834.25.75c.2334.2334.4166.25 2.75.25s2.5166-.0166 2.75-.25c.1666-.1666.25-.4166.25-.75s-.0834-.5834-.25-.75c-.2334-.2334-.4166-.25-2.75-.25s-2.5166.0166-2.75.25Zm36.627 16.194c2.3707.7943 4.7199 1.5249 5.2201 1.6236.5004.0988 1.067.2609 1.2594.3604.4922.2545 1.213 1.0861 1.3754 1.5869.1241.3828 1.0181 8.0223 1.0181 8.7003V72H53v-2.75c0-2.5834-.0151-2.7651-.25-3-.1666-.1666-.4166-.25-.75-.25s-.5834.0834-.75.25c-.2349.2349-.25.4166-.25 3V72H31v-2.75c0-2.5834-.0151-2.7651-.25-3-.1666-.1666-.4166-.25-.75-.25s-.5834.0834-.75.25c-.2349.2349-.25.4166-.25 3V72h-5.75v-.2848c0-.678.894-8.3175 1.0181-8.7003.1624-.5008.8831-1.3324 1.3754-1.5869.1924-.0995.759-.2617 1.2594-.3605.5002-.0987 2.8221-.825 5.1596-1.6137l4.25-1.4343 4.627-.0097L45.5666 58l4.3104 1.444ZM184.959 12.2768c-.224.1513-.532.4592-.684.6839l-.275.4085v52.602l.275.4085c.507.7515.963.9593 2.104.9593h1.012v.9121c0 1.0624.181 1.5774.713 2.0253.473.3973 1.074.5726 1.968.5735l.683.0007.045.8888c.036.7113.109.9856.365 1.3736.632.9548-.607.8859 15.918.8859h14.752l4.423-4.4182 4.424-4.4183.035-4.6512.036-4.6514.994-.0816c.546-.0449 1.328-.1322 1.738-.1941 1.95-.2946 4.996-1.5056 5.264-2.0926.264-.5796-.198-1.4097-.785-1.4097-.157 0-.743.2144-1.302.4764-3.728 1.7466-7.741 1.7093-11.43-.1062-.666-.3278-1.556-.8537-1.978-1.1685l-.767-.5725 4.4-4.4004c2.419-2.4201 4.454-4.4011 4.521-4.402.224-.0036 11.745 3.0597 11.845 3.1495.243.2184-.883 2.3772-1.997 3.8307-.681.8885-.753 1.3404-.287 1.806.688.6883 1.285.3179 2.545-1.5796 1.754-2.6423 2.486-5.128 2.486-8.4428 0-3.979-1.382-7.451-4.099-10.2942-2.666-2.7906-6.044-4.3416-10.099-4.6366l-1.181-.086v-2.8132c0-2.7257-.009-2.826-.275-3.2218-.507-.7515-.962-.9593-2.104-.9593h-1.012l-.001-.8779c-.004-1.6467-.758-2.3859-2.438-2.3895l-.926-.002-.043-1.0079c-.036-.8463-.094-1.0862-.365-1.4947-.638-.9643 1.051-.8879-19.628-.8879h-18.461l-.409.2754Zm36.752 1.6145c.144.0554.191.248.191.7864v.7129l-10.734.031-10.734.0309-.247.3307c-.206.2766-.228.4048-.134.784.073.2932.22.5074.416.6059.237.1198 2.946.1531 12.563.1544l12.261.0018v1.332l-16.499.002-16.499.002-.475.2704c-.297.1687-.582.4715-.757.8042l-.282.5337V68.9253l-.696-.0363-.696-.0364-.031-25.7564-.03-25.7563 3.507-.0356c3.882-.0393 3.825-.0273 3.955-.8311.051-.313.003-.4975-.194-.7483l-.262-.333h-3.698c-3.606 0-3.711.0068-4.181.2711-.27.1515-.611.4902-.774.7675l-.29.4963v48.4748H185.938V39.6803c0-20.4637.031-25.7337.151-25.7824.218-.088 35.393-.0945 35.622-.0066Zm7.02 6.899c.041.1053.074 1.2967.074 2.6475v2.4559l-.515.0713c-.886.1228-2.651.6845-3.709 1.1806-3.628 1.6999-6.544 4.9671-7.807 8.7476-.59 1.7653-.744 2.7767-.739 4.8668.005 2.1427.182 3.2414.808 5.0252 1.38 3.9342 4.359 7.131 8.187 8.7856.963.4159 3.067 1.0226 3.548 1.0226.217 0 .227.1733.227 4.0513v4.0514l-3.552.0353-3.552.0355-.457.3492c-.862.6577-.91.9056-.913 4.7063l-.003 3.3602h-13.613c-7.487 0-13.699-.0331-13.805-.0735-.174-.0668-.191-2.4447-.191-25.7112 0-14.1008.036-25.6741.081-25.7184.044-.0444 8.13-.0808 17.969-.0808 16.2 0 17.896.0181 17.962.1916Zm-30.607 6.3561c-.407.3201-.447 1.0739-.077 1.4442.238.2379.403.2422 9.566.2422s9.329-.0043 9.567-.2422c.161-.1614.242-.4036.242-.7265 0-.323-.081-.5652-.242-.7266-.238-.2379-.404-.2421-9.49-.2421-9.172 0-9.25.002-9.566.251Zm34.677.6519c1.478.2248 2.616.5775 2.565.7953-.02.0901-1.186 2.7282-2.59 5.8624l-2.553 5.6986-4.572 4.5888-4.572 4.5887-.617-.835c-5.022-6.7887-2.263-16.5923 5.582-19.8337 2.284-.9437 4.432-1.2187 6.757-.8651Zm5.493 2.0838c1.206.7884 3.02 2.6706 3.821 3.9651.782 1.2628 1.405 2.8549 1.732 4.4305.193.9304.229 1.491.19 2.9325-.026.9802-.081 1.8155-.121 1.8561-.08.0798-11.234-2.8284-11.394-2.9707-.112-.0996 4.646-10.775 4.804-10.777.057-.0009.493.2528.968.5635Zm-40.167 3.9214c-.41.3229-.452 1.075-.08 1.447.237.2368.403.2422 7.508.2422 7.104 0 7.271-.0054 7.507-.2422.289-.2885.327-1.0491.071-1.3997-.166-.2275-.405-.2361-7.428-.2681-7.207-.0328-7.257-.0312-7.578.2208Zm-.003 6.6626c-.407.3202-.447 1.074-.077 1.4443.236.236.403.2421 6.539.2421 6.135 0 6.303-.0061 6.539-.2421.245-.2448.334-1.008.15-1.2836-.26-.3888-.633-.4117-6.725-.4117-5.995 0-6.113.0046-6.426.251Zm6.248 10.046c-.151.0606-.328.2514-.393.424-.066.173-.12 1.56-.12 3.091v2.7772h-1.921c-1.76 0-1.948.0211-2.24.251l-.319.2509V64.3118h-.49c-.913 0-1.402.9126-.853 1.591l.232.2859 8.638.0327c6.102.023 8.733-.0067 8.961-.1013.624-.2584.734-1.2431.182-1.6295-.14-.0983-.461-.1788-.713-.1788h-.457v-9.3063l-.319-.2509c-.292-.2299-.48-.251-2.24-.251h-1.922v-1.629c0-1.7502-.093-2.139-.563-2.3536-.36-.1637-5.058-.1715-5.463-.0089Zm4.089 7.8058v5.9939h-2.664V52.324h2.664v5.9939Zm4.48 2.0585v3.9354h-2.543V56.441h2.543v3.9354Zm-9.082 1.1504v2.785h-2.543v-5.5701h2.543v2.7851Zm21.085 6.5239c-1.273 1.3238-2.397 2.4748-2.497 2.5577-.16.1332-.181-.138-.181-2.3262 0-1.3624.036-2.5133.08-2.5577.045-.0444 1.168-.0807 2.497-.0807h2.416l-2.315 2.4069Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M101 11v64M96 70h64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m107 56 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M105 67v-2M109 67v-2M113 67v-2M117 67v-2M121 67v-2M125 67v-2M129 67v-2M133 67v-2M137 67v-2M141 67v-2M145 67v-2M149 67v-2M153 67v-2M157 67v-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m119 44 5-5h14l19-19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M106 22h13l6 6 6-6h5l7 7M148 34l9 9M152 43h5v-5M157 25v-5h-5M153 59l4-4-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M157 55h-17l-6-6-8 8-19-19"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "equal",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.92 8.11597V10.348H4.97998V8.11597H19.92ZM19.92 13.984V16.216H4.97998V13.984H19.92Z",
    fill: "currentColor"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "info_outlined",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 3c.6 0 1 .4 1 1v4a1 1 0 1 1-2 0v-4c0-.6.4-1 1-1Z",
    clipRule: "evenodd"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "info_filled",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z",
    fill: "currentColor"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "info_exclamation",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F56B38",
    fillRule: "evenodd",
    d: "M10 18.3a8.3 8.3 0 1 0 0-16.6 8.3 8.3 0 0 0 0 16.6Zm0-8a.7.7 0 0 1-.8-.7V6.3a.8.8 0 0 1 1.5 0v3.3c0 .4-.3.7-.7.7ZM9.2 13a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0Z",
    clipRule: "evenodd"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z",
    fill: "currentColor"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3H10C8.897 3 8 3.897 8 5V6H4V8H6V19C6 20.103 6.897 21 8 21H16C17.103 21 18 20.103 18 19V8H20V6H16V5C16 3.897 15.103 3 14 3ZM10 5H14V6H10V5ZM16 19H8V8H16V19Z"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "manage_accounts",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12C8.9 12 7.95833 11.6083 7.175 10.825C6.39167 10.0417 6 9.1 6 8C6 6.9 6.39167 5.95833 7.175 5.175C7.95833 4.39167 8.9 4 10 4C11.1 4 12.0417 4.39167 12.825 5.175C13.6083 5.95833 14 6.9 14 8C14 9.1 13.6083 10.0417 12.825 10.825C12.0417 11.6083 11.1 12 10 12ZM2 20V17.2C2 16.65 2.14167 16.1333 2.425 15.65C2.70833 15.1667 3.1 14.8 3.6 14.55C4.45 14.1167 5.40833 13.75 6.475 13.45C7.54167 13.15 8.71667 13 10 13H10.35C10.45 13 10.55 13.0167 10.65 13.05C10.5167 13.35 10.404 13.6627 10.312 13.988C10.2207 14.3127 10.15 14.65 10.1 15H10C8.81667 15 7.754 15.15 6.812 15.45C5.87067 15.75 5.1 16.05 4.5 16.35C4.35 16.4333 4.22933 16.55 4.138 16.7C4.046 16.85 4 17.0167 4 17.2V18H10.3C10.4 18.35 10.5333 18.696 10.7 19.038C10.8667 19.3793 11.05 19.7 11.25 20H2ZM16 21L15.7 19.5C15.5 19.4167 15.3123 19.3293 15.137 19.238C14.9623 19.146 14.7833 19.0333 14.6 18.9L13.15 19.35L12.15 17.65L13.3 16.65C13.2667 16.4167 13.25 16.2 13.25 16C13.25 15.8 13.2667 15.5833 13.3 15.35L12.15 14.35L13.15 12.65L14.6 13.1C14.7833 12.9667 14.9623 12.854 15.137 12.762C15.3123 12.6707 15.5 12.5833 15.7 12.5L16 11H18L18.3 12.5C18.5 12.5833 18.6877 12.675 18.863 12.775C19.0377 12.875 19.2167 13 19.4 13.15L20.85 12.65L21.85 14.4L20.7 15.4C20.7333 15.6 20.75 15.8083 20.75 16.025C20.75 16.2417 20.7333 16.45 20.7 16.65L21.85 17.65L20.85 19.35L19.4 18.9C19.2167 19.0333 19.0377 19.146 18.863 19.238C18.6877 19.3293 18.5 19.4167 18.3 19.5L18 21H16ZM17 18C17.55 18 18.021 17.8043 18.413 17.413C18.8043 17.021 19 16.55 19 16C19 15.45 18.8043 14.979 18.413 14.587C18.021 14.1957 17.55 14 17 14C16.45 14 15.9793 14.1957 15.588 14.587C15.196 14.979 15 15.45 15 16C15 16.55 15.196 17.021 15.588 17.413C15.9793 17.8043 16.45 18 17 18ZM10 10C10.55 10 11.021 9.804 11.413 9.412C11.8043 9.02067 12 8.55 12 8C12 7.45 11.8043 6.97933 11.413 6.588C11.021 6.196 10.55 6 10 6C9.45 6 8.97933 6.196 8.588 6.588C8.196 6.97933 8 7.45 8 8C8 8.55 8.196 9.02067 8.588 9.412C8.97933 9.804 9.45 10 10 10Z"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "send",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 20V4L22 12L3 20ZM5 17L16.85 12L5 7V10.5L11 12L5 13.5V17ZM5 17V7V13.5V17Z"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "plusCircle",
    viewBox: "0 0 25 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 13L11.5 17H13.5V13H17.5V11H13.5V7H11.5L11.5 11H7.5V13H11.5Z",
    fill: "currentColor"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20L16 16",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "help_filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM9.3 7C10 6.3 11 6 12 6a3.9 3.9 0 0 1 4 4c0 1.8-1.1 2.7-2 3.2l-.3.3-.6.3-.1.2a1 1 0 0 1-2 0c0-.8.4-1.3.8-1.6l1-.7.1-.1c.7-.5 1.1-.9 1.1-1.6a2 2 0 0 0-.6-1.5C13 8.2 12.5 8 12 8c-.5 0-1 .2-1.4.5A2 2 0 0 0 10 10a1 1 0 1 1-2 0c0-1.3.5-2.3 1.3-3ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    clipRule: "evenodd"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "face",
    viewBox: "0 0 24 24",
    fill: "#2E9372"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8a1.3 1.3 0 1 0 0 2.5 1.3 1.3 0 0 0 0-2.6Zm6 0a1.3 1.3 0 1 0 0 2.5 1.3 1.3 0 0 0 0-2.6ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 0 1-8-8.9c2.4-1 4.3-3 5.3-5.3a10 10 0 0 0 10.4 4A8 8 0 0 1 12 20Z"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "video_settings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12L9 8V16L15 12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 1,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "live_help",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm-6 16h-2v-2h2v2Zm2-7.8-.8 1c-.8.7-1.2 1.3-1.2 2.8h-2v-.5a4 4 0 0 1 1.2-2.8l1.2-1.3c.4-.3.6-.8.6-1.4a2 2 0 0 0-2-2 2 2 0 0 0-2 2H8a4 4 0 1 1 8 0c0 .9-.4 1.7-1 2.3Z"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "ppt",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 2c-.88 0-1.6.72-1.6 1.6v16.8c0 .88.72 1.6 1.6 1.6h13c.88 0 1.6-.72 1.6-1.6V3.6 7l-5-5H5.5Z",
    fill: "#FF9333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.64 17v-3.07h2.19c1.71 0 2.58-.74 2.58-2.22 0-1.47-.85-2.21-2.57-2.21H9.8V17h.85Zm2.15-3.81h-2.15v-2.94h2.15c.6 0 1.03.11 1.33.36.29.22.44.6.44 1.1 0 .5-.15.87-.43 1.1-.3.25-.74.38-1.34.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 7h3.4l-5-5v3.4c0 .88.72 1.6 1.6 1.6Z",
    fill: "#E36334"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#E36334",
    d: "M19.63 6.53h-4.06l4.53 4.53V7l-.47-.47Z"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "ppt-error",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78 4.63a1.6 1.6 0 0 1 1.37-1.8l2.37-.34 2.38-.32 2.08 6.27-.66 6.15L12 19.4 10.1 22.2l-3.21.44a1.6 1.6 0 0 1-1.81-1.36L2.79 4.63Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 22.73a1.6 1.6 0 0 0 1.77-1.4l1.56-13.31-4.4-5.55L13.33 2l.73 6.63-1.68 5.84 1.4 5.2L12 21.98l6.46.75Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.36 7.5-4.03-.47 3.98 5.03.47-4.04-.42-.52Z",
    fill: "#43494D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4 7.63 3.38.4-4.4-5.55L17 5.85a1.6 1.6 0 0 0 1.4 1.78Z",
    fill: "#43494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.83 13.93c1.71 0 2.58-.74 2.58-2.22 0-1.18-.54-1.88-1.64-2.12l-.2.74c.22.07.4.16.55.28.29.22.44.6.44 1.1 0 .5-.15.87-.43 1.11-.3.24-.79.36-1.4.36l-.2.75h.3ZM8.46 14.16l.31 3.05-.85.09-.76-7.47 3.03-.3c.35-.04.4-.05.68-.02l-.08.76c-.23-.04-.28-.03-.57 0l-2.14.22.3 2.92 2.1-.31-.09.79-1.93.27Z",
    fill: "#CBD1D6"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "excel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#41C499",
    fillRule: "evenodd",
    d: "M5.5 2c-.9 0-1.6.7-1.6 1.6v16.8c0 .9.7 1.6 1.6 1.6h13c.9 0 1.6-.7 1.6-1.6V7l-5-5H5.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.8 17 2.2-3.2 2.3 3.2h1l-2.8-3.9 2.6-3.6h-1l-2.1 3-2-3H8.8l2.6 3.6L8.7 17h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26795E",
    d: "M16.7 7h3.4l-5-5v3.4c0 .9.7 1.6 1.6 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#26795E",
    d: "M19.6 6.5h-4l4.5 4.6V7l-.5-.5Z"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "excel-error",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78 4.63a1.6 1.6 0 0 1 1.37-1.8l2.37-.34 2.38-.32 2.08 6.27-.66 6.15L12 19.4 10.1 22.2l-3.21.44a1.6 1.6 0 0 1-1.81-1.36L2.79 4.63Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 22.73a1.6 1.6 0 0 0 1.77-1.4l1.56-13.31-4.4-5.55L13.33 2l.73 6.63-1.68 5.84 1.4 5.2L12 21.98l6.46.75Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.36 7.5-4.03-.47 3.98 5.03.47-4.04-.42-.52Z",
    fill: "#43494D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4 7.63 3.38.4-4.4-5.55L17 5.85a1.6 1.6 0 0 0 1.4 1.78Z",
    fill: "#43494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8 12.95 1.24 3.72 1.03.3-1.58-4.53L17 9.72l-1.02-.3-2.8 2.22-.38 1.31ZM10.49 13.1l-1.85 3.36-1.06.12 2.3-4.2-2.99-3.27 1.06-.13 2.67 2.84-.13 1.28Z",
    fill: "#CBD1D6"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.75v3.67a1.83 1.83 0 0 1-1.83 1.83H5.58a1.83 1.83 0 0 1-1.83-1.83v-3.67",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42 10.17 12 14.75l4.58-4.58",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.83V3.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-download-spinner",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 16.5c.47.28.64.9.32 1.34A10 10 0 0 1 2.88 7.89c.23-.5.85-.67 1.33-.39.47.28.63.89.42 1.4a8 8 0 0 0 13.75 7.93c.33-.44.94-.6 1.41-.33Z",
    fill: "currentColor"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "download-spinner",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 3.33965c4.7829 2.76142 6.4217 8.87735 3.6603 13.66025-2.7615 4.7829-8.8774 6.4217-13.6603 3.6603C2.21717 17.8987.57842 11.7828 3.33984 6.9999 6.10127 2.21698 12.2172.57822 17.0001 3.33965Zm-9 15.58845c3.8263 2.2091 8.7191.8981 10.9282-2.9282 2.2091-3.8263.8981-8.71906-2.9282-10.9282-3.8263-2.20914-8.71907-.89814-10.92821 2.9282-2.20913 3.8263-.89813 8.7191 2.92821 10.9282Z",
    fill: "#68D0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c0-.55228.4488-1.00519.9984-.95007 2.2855.22925 4.4341 1.24045 6.0727 2.879C20.9464 6.8043 22 9.34783 22 12c0 2.6522-1.0536 5.1957-2.9289 7.0711-1.6386 1.6385-3.7872 2.6497-6.0727 2.879C12.4488 22.0052 12 21.5523 12 21s.4495-.9935.9974-1.0624c1.754-.2204 3.3962-1.0175 4.6595-2.2807C19.1571 16.1566 20 14.1217 20 12c0-2.12173-.8429-4.15656-2.3431-5.65685-1.2633-1.26325-2.9055-2.06039-4.6595-2.28076C12.4495 3.99355 12 3.55228 12 3Z",
    fill: "#fff"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "repeat",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.1a5 5 0 0 1-3.3-1.2A5 5 0 0 1 3 9h1.6A3.5 3.5 0 0 0 8 11.6c1 0 1.8-.4 2.5-1 .7-.8 1-1.6 1-2.6s-.3-1.8-1-2.5-1.5-1-2.5-1a3.5 3.5 0 0 0-2.5 1H7V7H2.9V2.9h1.5v1.5A5.3 5.3 0 0 1 8 2.9a5 5 0 0 1 3.6 1.5A5 5 0 0 1 13.1 8a5 5 0 0 1-1.5 3.6A5 5 0 0 1 8 13.1Z"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "status-downloaded",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "#36AD86",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeWidth: 1.5,
    d: "M5 7.7 7.3 10 11 6.3"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "status-ready",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "#36AD86",
    strokeWidth: 1.5
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "status-failed",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 10.3333L10.3332 5.66666",
    stroke: "#F56B38",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 5.66666L10.3332 10.3333",
    stroke: "#F56B38",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "#F56B38",
    strokeWidth: 1.5
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-file-reject",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 17 6-6M9 11l6 6",
    stroke: "#CBD1D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4v16c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V7.4a1 1 0 0 0-.3-.7l-3.4-3.4a1 1 0 0 0-.7-.3H6a1 1 0 0 0-1 1Z",
    stroke: "#CBD1D6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7V3l5 5h-4a1 1 0 0 1-1-1Z",
    fill: "#CBD1D6"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron_down_small",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 10 4 4 4-4",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check_medium",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 11.86 3.57 3.57L17 9",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bar_chart_horizontal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3h2v18H3V3ZM21 11V9H6v2h15ZM13 7V5H6v2h7ZM18 13v2H6v-2h12ZM15 19v-2H6v2h9Z"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location_outline",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10.2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14ZM12 2c4.2 0 8 3.22 8 8.2 0 3.18-2.45 6.93-7.35 11.24a.98.98 0 0 1-1.3 0C6.45 17.13 4 13.38 4 10.2 4 5.22 7.8 2 12 2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings-fill",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.2 14.074.8.661c.38.309.481.847.24 1.273l-1.16 2.004a.999.999 0 0 1-1.15.43l-1-.36a1.997 1.997 0 0 0-1.78.19 5.485 5.485 0 0 1-.74.431c-.563.29-.956.828-1.06 1.453l-.17 1.002a1 1 0 0 1-1 .842h-2.3a1 1 0 0 1-1-.842l-.17-1.002a2.004 2.004 0 0 0-1.06-1.453 5.484 5.484 0 0 1-.74-.43 1.997 1.997 0 0 0-1.78-.19l-1 .36a.999.999 0 0 1-1.21-.431l-1.16-2.004A1.003 1.003 0 0 1 3 14.735l.8-.66a2.006 2.006 0 0 0 .72-1.644v-.861a2.006 2.006 0 0 0-.72-1.644L3 9.265a1.003 1.003 0 0 1-.24-1.273l1.16-2.004a.999.999 0 0 1 1.19-.43l1 .36c.59.22 1.25.15 1.78-.19.235-.163.483-.307.74-.431a2.004 2.004 0 0 0 1.02-1.453l.17-1.002a1 1 0 0 1 1-.842h2.3a1 1 0 0 1 1 .842l.17 1.002a2.004 2.004 0 0 0 1.06 1.453c.258.124.505.268.74.43.53.341 1.19.412 1.78.19l1-.36a.999.999 0 0 1 1.21.431l1.16 2.004c.241.426.14.964-.24 1.273l-.8.66a2.006 2.006 0 0 0-.72 1.644v.861c-.032.632.235 1.24.72 1.644ZM9 12a3.003 3.003 0 0 0 3 3.006c.796 0 1.559-.317 2.121-.88A3.01 3.01 0 0 0 15 12a3.003 3.003 0 0 0-3-3.006c-1.657 0-3 1.346-3 3.006Z"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trend",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63 18.18 1 17l5-8 3 3.5L13 6l2.72 4.07a6.4 6.4 0 0 0-2.1.46l-.54-.83-3.8 6.18-3.03-3.53-3.63 5.83ZM21.57 23l-3.13-3.13c-.33.24-.7.41-1.11.53a4.57 4.57 0 0 1-4.45-1.14 4.34 4.34 0 0 1-1.32-3.19c0-1.25.44-2.3 1.32-3.18a4.34 4.34 0 0 1 3.18-1.32c1.25 0 2.32.44 3.2 1.32a4.57 4.57 0 0 1 .61 5.59l3.12 3.1L21.57 23Zm-5.5-4.43c.7 0 1.29-.24 1.77-.72s.72-1.08.72-1.78-.24-1.29-.72-1.77a2.41 2.41 0 0 0-1.78-.73c-.7 0-1.29.25-1.77.73a2.41 2.41 0 0 0-.73 1.77c0 .7.25 1.3.73 1.78s1.07.72 1.77.72Zm2.22-8a6.52 6.52 0 0 0-2.05-.47L21.38 2 23 3.17l-4.7 7.4Z"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pie-chart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-3.94 5.23A7.97 7.97 0 0 0 19.94 13h-6.11l4.23 4.23Zm-1.5 1.34A8 8 0 1 1 11 4.07v8.3c.01.4.17.79.45 1.07l5.13 5.13ZM13 11h6.94A8 8 0 0 0 13 4.06V11Z",
    clipRule: "evenodd"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-top-box",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21c-.55 0-1.02-.2-1.41-.59-.4-.39-.59-.86-.59-1.41V6.5c0-.25.04-.47.13-.67.08-.2.19-.4.32-.58l1.4-1.7c.13-.18.3-.32.5-.41.2-.1.42-.14.65-.14h12c.23 0 .45.05.65.14.2.09.37.23.5.41l1.4 1.7c.13.18.24.38.32.58.09.2.13.42.13.67V19c0 .55-.2 1.02-.59 1.41-.39.4-.86.59-1.41.59H5Zm.4-15h13.2l-.85-1H6.25L5.4 6ZM5 8v11h14V8H5Zm6 10h2v-4.2l1.6 1.6L16 14l-4-4-4 4 1.4 1.4 1.6-1.6V18Zm-6 1h14H5Z"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bip",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17V7h4.02c.83 0 1.55.24 2.18.73.62.49.93 1.12.93 1.88a2.38 2.38 0 0 1-1.35 2.14v.14c.5.17.92.46 1.24.89.32.42.48.9.48 1.43 0 .83-.34 1.5-1.02 2.01-.68.52-1.46.78-2.35.78H2.5Zm1.93-5.93h1.94c.37 0 .7-.11.97-.34.28-.22.42-.51.42-.86 0-.34-.14-.63-.42-.85a1.5 1.5 0 0 0-.97-.34H4.43v2.4Zm0 4.22h2.09c.41 0 .77-.13 1.08-.37.3-.24.46-.56.46-.94 0-.38-.16-.7-.46-.94-.3-.24-.67-.36-1.08-.36H4.43v2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.37 17V7H18.4c.82 0 1.55.24 2.17.73.62.49.93 1.12.93 1.87v.54c0 .76-.3 1.39-.93 1.87-.62.5-1.35.74-2.17.74H16.3V17h-1.94Zm4.85-7.98c.28.22.42.51.42.86 0 .34-.14.62-.42.85-.28.22-.6.34-.97.34H16.3v-2.4h1.94c.36 0 .69.12.97.35Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7v10h1.93V7h-1.93Z"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-text-divider",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 21.2c-.7 0-1.3-.3-1.7-.8-.5-.4-.7-1-.7-1.7V5.3c0-.7.2-1.3.7-1.7.4-.5 1-.7 1.7-.7h13.4c.7 0 1.3.2 1.7.7.5.4.8 1 .8 1.7v13.4c0 .7-.3 1.3-.8 1.7-.4.5-1 .8-1.7.8H5.3Zm0-2.2h13.4l.2-.1.1-.2V5.3l-.1-.2-.2-.1H5.3l-.2.1-.1.2v13.4l.1.2.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10h2v6h-2zM9 10V8h6v2z"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-duplicate",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 14h2v-3h3V9h-3V6h-2v3h-3v2h3v3Zm-5 4a2 2 0 0 1-1.4-.6A2 2 0 0 1 6 16V4c0-.5.2-1 .6-1.4A2 2 0 0 1 8 2h12c.6 0 1 .2 1.4.6.4.4.6.9.6 1.4v12c0 .6-.2 1-.6 1.4a2 2 0 0 1-1.4.6H8Zm0-2h12V4H8v12Zm-4 6a2 2 0 0 1-1.4-.6A2 2 0 0 1 2 20V6h2v14h14v2H4ZM8 4v12V4Z"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-move-up",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m8 11 4-4 4 4M12 7v11"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-move-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#icon-move-up",
    width: 24,
    height: 24,
    transform: "rotate(180, 12, 12)"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-reorder",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4a1 1 0 0 0-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H5Zm10 10a1 1 0 0 0-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4Zm0-8h4c.6 0 1 .4 1 1v4.5h-2V8h-3v2l-2-2-1-1 1-1 2-2v2ZM9 18H5a1 1 0 0 1-1-1v-4.5h2V16h3v-2l2 2 1 1-1 1-2 2v-2Z",
    clipRule: "evenodd"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drag-handle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-8-4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM9 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    clipRule: "evenodd"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check-filled",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#36AD86"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "m4 7.5 3 3 5-5"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-no_data_folder",
    fill: "none",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53 41.46h37.15A2.32 2.32 0 0 0 43 39.15V11.28a2.32 2.32 0 0 0-2.32-2.32H3.53a2.32 2.32 0 0 0-2.32 2.32v27.87a2.32 2.32 0 0 0 2.32 2.31Z",
    stroke: "currentColor",
    strokeWidth: 2.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.63v6.98l2.12-4.65h23.72V7.8l-.45-.02a2 2 0 0 1-1.33-.59l-4.12-4.12A3.63 3.63 0 0 0 17.37 2H4.63A4.63 4.63 0 0 0 0 6.63Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.63 34.37 17.59-17.53M13.63 16.84l17.59 17.53",
    stroke: "currentColor",
    strokeWidth: 2.42,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.34cb2b30519327c460c805e8d4f832cb.svg";
export { ForwardRef as ReactComponent };